export function init() {
  // Make labels smaller on input
  let forms = Array.from(document.querySelectorAll("form:not([role=search])"));
  let allInputs = [];
  for (let form of forms) {
    let inputs = Array.from(form.querySelectorAll("label + input"));
    allInputs = allInputs.concat(inputs);
  }
  for (let input of allInputs) {
    /*  input.addEventListener("click", () => {
      input.previousElementSibling.classList.add("label-small");
    }); */
    input.addEventListener("focus", () => {
      input.previousElementSibling.classList.add("label-small");
    });
  }
}
